'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _Measure = require('./Measure');

var _Measure2 = _interopRequireDefault(_Measure);

exports['default'] = _Measure2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-measure/lib/react-measure.js
// module id = 411
// module chunks = 0